import React, { useEffect, useState } from 'react';
import { Clock, ArrowRight } from 'lucide-react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 14,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds === 0) {
          if (prev.minutes === 0) return prev;
          return {
            minutes: prev.minutes - 1,
            seconds: 59
          };
        }
        return {
          ...prev,
          seconds: prev.seconds - 1
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const scrollToPrecios = () => {
    document.getElementById('precios')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="bg-brand-primary text-white py-3 px-4 text-center sticky top-0 z-50 shadow-md" data-id="element-282">
      <button onClick={scrollToPrecios} className="flex items-center justify-center gap-2 text-sm md:text-base font-medium w-full group" data-id="element-283">
        <Clock className="w-4 h-4 animate-pulse shrink-0" data-id="element-284" />
        <span data-id="element-285">
          <span className="font-bold text-brand-soft" data-id="element-286">OFERTA RELÁMPAGO:</span>{' '}
          El precio sube a $97 en{' '}
          <span className="font-mono font-bold bg-white/20 px-2 py-0.5 rounded" data-id="element-287">
            {String(timeLeft.minutes).padStart(2, '0')}:
            {String(timeLeft.seconds).padStart(2, '0')}
          </span>
        </span>
        <span className="hidden sm:inline-flex items-center gap-1 ml-2 underline underline-offset-2 text-brand-soft group-hover:text-white transition-colors text-xs font-bold uppercase tracking-wider" data-id="element-288">
          Ver oferta <ArrowRight className="w-3 h-3" data-id="element-289" />
        </span>
      </button>
    </div>;
}